import { Button, Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import * as React from "react";
import { useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
// import SaveProductButton from "./SaveProductButton";
import { useRecordContext } from "react-admin";
import ShowUploadDocsField from "./uploadDocs/ShowUploadDocsField";
import CustomProductActionBottom from "../CustomProductActionBottom";
import { useWatch } from "react-hook-form";
import customSortArrays from "../../unit/sortArrays";
export default function UploadDocs({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const data = record?.data?.basic?.uploaddocs;
  const coreCodeDataShow = data?.coreCodeDataShow;
  const coreCodeData = data?.coreCodeData;
  const proof_documents = data?.proof_documents;
  const statements_checkbox = data?.statements_checkbox;
  // console.log("coreCodeDataShow", coreCodeDataShow);

  const division = record?.data?.basic?.division;
  const subType = record?.data?.basic?.subType;
  const productType = record?.data?.basic?.type;
  const sectionName = "uploaddocs";
  const sectionTitle =
    "Upload Docs - Describe documents to be uploaded by applicant";
  const sectionSubtitle = 'Select "N/A" if the document is not required';
  const [showDetail, setShowDetail] = React.useState(false);
  const [isActualDirty, setIsActualDirty] = React.useState(false);
  const [initialValuesSet, setInitialValuesSet] = React.useState({});
  const [isSaving, setIsSaving] = React.useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    reset,
    getValues,
  } = useForm<any>({
    mode: "onBlur",
    defaultValues: {},
  });
  const allValues = useWatch({ control });
  const hasSetBaseline = React.useRef(false);

  React.useEffect(() => {
    // 使用 requestAnimationFrame 确保在渲染后执行
    const rafId = requestAnimationFrame(() => {
      if (!hasSetBaseline.current) {
        const currentValues = getValues();
        setInitialValuesSet(currentValues);
        reset(currentValues);
        hasSetBaseline.current = true;
        // console.log("Check 首次渲染基准已设置====》", currentValues);
      }
    });

    return () => cancelAnimationFrame(rafId);
  }, [getValues, reset]);

  React.useEffect(() => {
    //对比时，如果里面又数组，数组里面的值顺序不一样也会被认为不一样，所以需要特殊处理， 先把数组排序后再对比

    const hasChanges =
      JSON.stringify(customSortArrays(initialValuesSet)) !==
      JSON.stringify(customSortArrays(allValues));
    setIsActualDirty(hasChanges);

    // console.log("Check 是否有修改====>:", hasChanges);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, hasChanges);
    }
  }, [allValues]);

  const handleSaveClick = async () => {
    setIsSaving(true);
    const formData = getValues();
    // console.log("Check 保存时表单数据====》", formData);

    formData.saveAction = sectionName;
    try {
      if (onSave) {
        await Promise.resolve(onSave(formData, props?.curMenu));
        // 保存后更新基准，但不触发不必要的重置
        reset(formData);
        setInitialValuesSet(formData);
        setIsActualDirty(false);
        reset(formData);
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {coreCodeDataShow &&
              coreCodeDataShow.map((item: any, index: any) => (
                <>
                  <ShowUploadDocsField
                    control={control}
                    item={item}
                    statements_checkbox_checked={statements_checkbox}
                    // coreCodeData={coreCodeData}
                  />
                </>
              ))}
          </Grid>
          {/* Form Actions */}
        </Grid>
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          // disabled={!isDirty}
          disabled={!isActualDirty || isSaving}
          sx={{ width: "120px", mt: 1 }}
        >
          {isSaving ? (
            <>
              Saving
              <CircularProgress size={16} color="inherit" />
            </>
          ) : (
            "Save"
          )}
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
